"use strict";
/**
 *  timeCueModule Module
 *
    Description 策划中心 指挥监测中心 地域热点功能列表
 *  Author: fanglijuan 2017-7-17
 */
angular.module('planCommandMonitorRegionalHotFeatureListModule', [])
    .controller('planCommandMonitorRegionalHotFeatureListCtrl', ["$scope", "$filter", "trsHttpService", 'planCommandMonitorService', '$q',
        function($scope, $filter, trsHttpService, planCommandMonitorService, $q) {
            initData();
            /**
             * [initData description:初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                judgeCity().then(function() {
                    requestData();
                });
            }
            /**
             * [requestData description] 请求数据
             */
            function requestData() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'areaHotPointFuncMgr',
                    "method": 'getAreaHotfunclist',
                    "iscloud": 0,
                    "sceneid": 1
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {

                    if ($scope.isAdd) {
                        $scope.hotFeatureList = data.mapResult.content;
                    } else {
                        var copyList = [];
                        for (var i = 0; i < data.mapResult.content.length; i ++) {
                            if (data.mapResult.content[i].id != '9' && data.mapResult.content[i].id != '10') {
                                copyList.push(data.mapResult.content[i]);
                            }
                        }
                        $scope.hotFeatureList = copyList;
                    }
                    // $scope.hotFeatureList = data.mapResult.content;
                });
            }
            /**
             * [judgeCity 获取地域热点管理中城市参数]
             * @return {[type]} [description]
             */
            function judgeCity() {
                var defer = $q.defer();
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'searchAreaHot',
                    "sceneid": 10
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.city === null || data.city === '') {
                        $scope.isAdd = false;
                    } else {
                        $scope.isAdd = true;
                    }
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [scan description:用于查看时打开网页]
             * @param  {[type]} url [description]
             * @return {[type]}     [description]
             */
            $scope.scan = function(item) {
                window.open(item);
            };
            /**
             * [shartHot description:分享地域热点信息]
             * @return {[type]} [description]
             */
            $scope.shareHot = function(id) {
                planCommandMonitorService.share(id, '3', "复制链接和密码");
            };
        }
    ]);